<template>
  <button
    class="whitebutton-gemnote full-btn whitebutton-gemnote--small okta-btn flex items-center justify-center gap-1.5 w-full"
    :disabled="loggingIn"
    @click="handleEmailSignIn"
  >
    <img src="../../assets/email.svg" alt="" class="w-5.5 h-5.5" />
    <span>Sign in with email</span>
  </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EmailSignIn',
  data() {
    return {}
  },

  computed: mapState({
    loggingIn: state => state.auth.loggingIn
  }),

  methods: {
    handleEmailSignIn() {
      this.$emit('onEmailSignIn')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.okta-btn {
  &.whitebutton-gemnote--small {
    font-family: 'Inter', sans-serif;
    height: 40px !important;
    text-transform: none !important;
    font-weight: 500;
  }
}
</style>
